import styled from "styled-components";
import {radii} from "theme/tokens";

/**
 * The pricing sheet (owner direction "Single Sheet", ui#2426): one panel on the card surface with the
 * card radius and shadow, the coupon band across its top, the tier columns separated by hairlines, and
 * the VAT statement as its foot. The compare table below it is a separate surface and unchanged.
 */
export const Sheet = styled.div`
	width: 100%;
	margin: 0 auto;
	border-radius: ${radii.card};
	background: ${({theme}) => theme.tokens.card};
	box-shadow: ${({theme}) => theme.tokens.shadowCard};
	overflow: hidden;
	text-align: left;
`;

/**
 * Hairlines between columns, never borders on them: a left hairline on every column after the first
 * on the wide layout, a top hairline where the columns stack on a phone.
 */
export const Columns = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	align-items: stretch;

	& > * + * {
		border-left: 1px solid ${({theme}) => theme.tokens.line};
	}

	@media (max-width: 760px) {
		grid-template-columns: minmax(0, 1fr);

		& > * + * {
			border-left: 0;
			border-top: 1px solid ${({theme}) => theme.tokens.line};
		}
	}
`;

/** The sheet's foot: the VAT statement every locale must keep near the prices (ui#2205). */
export const Foot = styled.p`
	margin: 0;
	padding: 13px 22px;
	border-top: 1px solid ${({theme}) => theme.tokens.line};
	text-align: center;
	font-size: 12px;
	line-height: 1.4;
	color: ${({theme}) => theme.tokens.ink2};
`;
